// @ts-nocheck
/**
 * ツインキー装備データ定義
 *
 * 設計書: twin_key_phase2_design.md
 * 参照: alchemy_system.md
 */

/**
 * 装備スロット
 */
export const EQUIPMENT_SLOTS = {
  WEAPON: 'WEAPON',       // 武器
  ARMOR: 'ARMOR',         // 防具
  ACCESSORY: 'ACCESSORY', // アクセサリ
  SPECIAL: 'SPECIAL',     // 特殊装備
};

/**
 * 装備スロット解放レベル
 */
export const EQUIPMENT_SLOT_UNLOCK = {
  [EQUIPMENT_SLOTS.WEAPON]: 1,     // Lv.1で解放
  [EQUIPMENT_SLOTS.ARMOR]: 1,      // Lv.1で解放
  [EQUIPMENT_SLOTS.SPECIAL]: 1,    // Lv.1で解放
  [EQUIPMENT_SLOTS.ACCESSORY]: 1,  // Lv.1で解放
};

/**
 * 装備タイプ
 */
export const EQUIPMENT_TYPES = {
  // 武器
  SWORD: 'SWORD',           // 剣
  STAFF: 'STAFF',           // 杖
  BOW: 'BOW',               // 弓
  AXE: 'AXE',               // 斧
  CLAW: 'CLAW',             // 爪
  FANG: 'FANG',             // 牙

  // 防具
  LIGHT_ARMOR: 'LIGHT_ARMOR',   // 軽鎧
  HEAVY_ARMOR: 'HEAVY_ARMOR',   // 重鎧
  ROBE: 'ROBE',                 // ローブ
  SCALE: 'SCALE',               // 鱗鎧

  // アクセサリ
  RING: 'RING',             // 指輪
  AMULET: 'AMULET',         // 護符
  ORB: 'ORB',               // オーブ
  CHARM: 'CHARM',           // 魔除け

  // 特殊装備
  EMBLEM: 'EMBLEM',         // 紋章
  BADGE: 'BADGE',           // バッジ
  TALISMAN: 'TALISMAN',     // タリスマン
  ARTIFACT: 'ARTIFACT',     // アーティファクト
};

/**
 * 装備レアリティ
 */
export const EQUIPMENT_RARITY = {
  COMMON: 'COMMON',         // コモン
  UNCOMMON: 'UNCOMMON',     // アンコモン
  RARE: 'RARE',             // レア
  EPIC: 'EPIC',             // エピック
  LEGENDARY: 'LEGENDARY',   // レジェンダリー
};

/**
 * レアリティ別基礎ステータス倍率
 */
export const RARITY_MULTIPLIER = {
  [EQUIPMENT_RARITY.COMMON]: 1.0,
  [EQUIPMENT_RARITY.UNCOMMON]: 1.2,
  [EQUIPMENT_RARITY.RARE]: 1.5,
  [EQUIPMENT_RARITY.EPIC]: 1.8,
  [EQUIPMENT_RARITY.LEGENDARY]: 2.2,
};

/**
 * 強化レベル上限
 */
export const MAX_ENHANCE_LEVEL = 10;

/**
 * 強化レベル別ステータス倍率
 */
export const ENHANCE_MULTIPLIER = {
  0: 1.00,
  1: 1.05,
  2: 1.10,
  3: 1.16,
  4: 1.22,
  5: 1.30,
  6: 1.38,
  7: 1.47,
  8: 1.57,
  9: 1.68,
  10: 1.80,
};

/**
 * 装備効果タイプ
 *
 * @deprecated
 * このオブジェクトは非推奨です。
 * 装備効果タイプは recipes.js (crafting_system_design.md) で定義された
 * 小文字スネークケース形式を使用してください。
 *
 * 例: 'attribute_resistance', 'category_boost', 'faction_boost' など
 *
 * 日本語表示は effectDescriptions.js の getEffectDescription() を使用。
 *
 * @see src/twinKey/content/alchemy/data/recipes.js
 * @see src/twinKey/content/alchemy/data/effectDescriptions.js
 * @see src/ルール/TwinKey/crafting_system_design.md
 */
export const EQUIPMENT_EFFECT_TYPES = {
  // 基本ステータス
  ATK_FLAT: 'ATK_FLAT',           // 攻撃力固定値
  ATK_PERCENT: 'ATK_PERCENT',     // 攻撃力%
  HP_FLAT: 'HP_FLAT',             // HP固定値
  HP_PERCENT: 'HP_PERCENT',       // HP%
  DEF_FLAT: 'DEF_FLAT',           // 防御固定値
  SPD_FLAT: 'SPD_FLAT',           // 速度固定値

  // 戦闘効果
  CRIT_RATE: 'CRIT_RATE',         // クリティカル率
  CRIT_DMG: 'CRIT_DMG',           // クリティカルダメージ
  LIFESTEAL: 'LIFESTEAL',         // 吸収率
  DAMAGE_BONUS: 'DAMAGE_BONUS',   // 与ダメージ増加
  DAMAGE_REDUCE: 'DAMAGE_REDUCE', // 被ダメージ軽減

  // 属性効果
  ATTRIBUTE_BONUS: 'ATTRIBUTE_BONUS', // 属性ダメージボーナス
  ATTRIBUTE_RESIST: 'ATTRIBUTE_RESIST', // 属性耐性

  // 特殊効果
  STATUS_INFLICT: 'STATUS_INFLICT',   // 状態異常付与確率
  STATUS_RESIST: 'STATUS_RESIST',     // 状態異常耐性
  SKILL_POWER: 'SKILL_POWER',         // スキル威力
  CD_REDUCE: 'CD_REDUCE',             // クールダウン短縮
};

/**
 * 装備ベースデータ
 */
export const EQUIPMENT_BASE_DATA = {
  // === 武器 ===
  iron_sword: {
    id: 'iron_sword',
    name: '鉄の剣',
    slot: EQUIPMENT_SLOTS.WEAPON,
    type: EQUIPMENT_TYPES.SWORD,
    rarity: EQUIPMENT_RARITY.COMMON,
    effects: [
      { type: EQUIPMENT_EFFECT_TYPES.ATK_FLAT, value: 50 },
    ],
    description: '基本的な鉄製の剣',
  },
  flame_blade: {
    id: 'flame_blade',
    name: '炎刃',
    slot: EQUIPMENT_SLOTS.WEAPON,
    type: EQUIPMENT_TYPES.SWORD,
    rarity: EQUIPMENT_RARITY.RARE,
    attribute: '炎',
    effects: [
      { type: EQUIPMENT_EFFECT_TYPES.ATK_FLAT, value: 80 },
      { type: EQUIPMENT_EFFECT_TYPES.ATTRIBUTE_BONUS, attribute: '炎', value: 0.15 },
    ],
    description: '炎の力を宿した剣',
    setId: 'flame_set',
  },
  frost_staff: {
    id: 'frost_staff',
    name: '氷結の杖',
    slot: EQUIPMENT_SLOTS.WEAPON,
    type: EQUIPMENT_TYPES.STAFF,
    rarity: EQUIPMENT_RARITY.RARE,
    attribute: '水',
    effects: [
      { type: EQUIPMENT_EFFECT_TYPES.ATK_FLAT, value: 60 },
      { type: EQUIPMENT_EFFECT_TYPES.STATUS_INFLICT, statusType: 'FREEZE', value: 0.10 },
    ],
    description: '凍結の力を持つ杖',
    setId: 'frost_set',
  },
  dragon_fang: {
    id: 'dragon_fang',
    name: '竜牙',
    slot: EQUIPMENT_SLOTS.WEAPON,
    type: EQUIPMENT_TYPES.FANG,
    rarity: EQUIPMENT_RARITY.EPIC,
    effects: [
      { type: EQUIPMENT_EFFECT_TYPES.ATK_FLAT, value: 100 },
      { type: EQUIPMENT_EFFECT_TYPES.CRIT_RATE, value: 0.10 },
    ],
    description: '強大な竜の牙から作られた武器',
    setId: 'dragon_set',
  },

  // === 防具 ===
  leather_armor: {
    id: 'leather_armor',
    name: '革鎧',
    slot: EQUIPMENT_SLOTS.ARMOR,
    type: EQUIPMENT_TYPES.LIGHT_ARMOR,
    rarity: EQUIPMENT_RARITY.COMMON,
    effects: [
      { type: EQUIPMENT_EFFECT_TYPES.HP_FLAT, value: 100 },
      { type: EQUIPMENT_EFFECT_TYPES.DEF_FLAT, value: 10 },
    ],
    description: '基本的な革製の鎧',
  },
  flame_armor: {
    id: 'flame_armor',
    name: '炎鎧',
    slot: EQUIPMENT_SLOTS.ARMOR,
    type: EQUIPMENT_TYPES.HEAVY_ARMOR,
    rarity: EQUIPMENT_RARITY.RARE,
    attribute: '炎',
    effects: [
      { type: EQUIPMENT_EFFECT_TYPES.HP_FLAT, value: 150 },
      { type: EQUIPMENT_EFFECT_TYPES.DEF_FLAT, value: 20 },
      { type: EQUIPMENT_EFFECT_TYPES.ATTRIBUTE_RESIST, attribute: '水', value: 0.15 },
    ],
    description: '炎の加護を受けた鎧',
    setId: 'flame_set',
  },
  frost_robe: {
    id: 'frost_robe',
    name: '氷結のローブ',
    slot: EQUIPMENT_SLOTS.ARMOR,
    type: EQUIPMENT_TYPES.ROBE,
    rarity: EQUIPMENT_RARITY.RARE,
    attribute: '水',
    effects: [
      { type: EQUIPMENT_EFFECT_TYPES.HP_FLAT, value: 120 },
      { type: EQUIPMENT_EFFECT_TYPES.SKILL_POWER, value: 0.10 },
    ],
    description: '氷の力を増幅するローブ',
    setId: 'frost_set',
  },
  dragon_scale: {
    id: 'dragon_scale',
    name: '竜鱗鎧',
    slot: EQUIPMENT_SLOTS.ARMOR,
    type: EQUIPMENT_TYPES.SCALE,
    rarity: EQUIPMENT_RARITY.EPIC,
    effects: [
      { type: EQUIPMENT_EFFECT_TYPES.HP_FLAT, value: 200 },
      { type: EQUIPMENT_EFFECT_TYPES.DEF_FLAT, value: 30 },
      { type: EQUIPMENT_EFFECT_TYPES.DAMAGE_REDUCE, value: 0.10 },
    ],
    description: '竜の鱗で作られた堅牢な鎧',
    setId: 'dragon_set',
  },

  // === アクセサリ ===
  power_ring: {
    id: 'power_ring',
    name: '力の指輪',
    slot: EQUIPMENT_SLOTS.ACCESSORY,
    type: EQUIPMENT_TYPES.RING,
    rarity: EQUIPMENT_RARITY.COMMON,
    effects: [
      { type: EQUIPMENT_EFFECT_TYPES.ATK_PERCENT, value: 0.05 },
    ],
    description: '攻撃力を高める指輪',
  },
  flame_amulet: {
    id: 'flame_amulet',
    name: '炎の護符',
    slot: EQUIPMENT_SLOTS.ACCESSORY,
    type: EQUIPMENT_TYPES.AMULET,
    rarity: EQUIPMENT_RARITY.RARE,
    attribute: '炎',
    effects: [
      { type: EQUIPMENT_EFFECT_TYPES.ATTRIBUTE_BONUS, attribute: '炎', value: 0.10 },
      { type: EQUIPMENT_EFFECT_TYPES.STATUS_RESIST, statusType: 'FREEZE', value: 0.30 },
    ],
    description: '炎属性の力を高め、凍結耐性を付与',
    setId: 'flame_set',
  },
  frost_orb: {
    id: 'frost_orb',
    name: '氷結のオーブ',
    slot: EQUIPMENT_SLOTS.ACCESSORY,
    type: EQUIPMENT_TYPES.ORB,
    rarity: EQUIPMENT_RARITY.RARE,
    attribute: '水',
    effects: [
      { type: EQUIPMENT_EFFECT_TYPES.ATTRIBUTE_BONUS, attribute: '水', value: 0.10 },
      { type: EQUIPMENT_EFFECT_TYPES.CD_REDUCE, value: 1 },
    ],
    description: '水属性スキルのクールダウンを短縮',
    setId: 'frost_set',
  },
  dragon_heart: {
    id: 'dragon_heart',
    name: '竜心の宝珠',
    slot: EQUIPMENT_SLOTS.ACCESSORY,
    type: EQUIPMENT_TYPES.ORB,
    rarity: EQUIPMENT_RARITY.EPIC,
    effects: [
      { type: EQUIPMENT_EFFECT_TYPES.HP_PERCENT, value: 0.15 },
      { type: EQUIPMENT_EFFECT_TYPES.CRIT_DMG, value: 0.20 },
    ],
    description: '竜の心臓から作られた強力なオーブ',
    setId: 'dragon_set',
  },
};

/**
 * ヘルパー関数: スロットが解放されているか
 */
export const isSlotUnlocked = (slot, level) => {
  const required = EQUIPMENT_SLOT_UNLOCK[slot];
  return level >= required;
};

/**
 * ヘルパー関数: 装備データ取得
 */
export const getEquipmentData = (equipmentId) => {
  return EQUIPMENT_BASE_DATA[equipmentId] || null;
};

/**
 * ヘルパー関数: 装備の最終ステータス計算
 *
 * 効果の取得優先順位:
 * 1. equipment.effects（recipes.js で作成された装備）
 * 2. EQUIPMENT_BASE_DATA[id].effects（旧形式の定義済み装備）
 *
 * recipes.js 形式対応（v3.0）
 */
export const calculateEquipmentStats = (equipment) => {
  // recipes.js 形式: 装備オブジェクト自体に effects が定義されている
  if (equipment.effects && Array.isArray(equipment.effects) && equipment.effects.length > 0) {
    const rarityMult = RARITY_MULTIPLIER[equipment.rarity] || 1;
    const enhanceMult = ENHANCE_MULTIPLIER[equipment.enhanceLevel || 0] || 1;
    const totalMult = rarityMult * enhanceMult;

    return equipment.effects.map((effect) => {
      // recipes.js は value または bonus を使用
      const baseValue = effect.value ?? effect.bonus ?? 0;

      // %系効果の判定（小文字形式対応）
      const isPercent = effect.type.includes('PERCENT') ||
                       effect.type.includes('RATE') ||
                       effect.type.includes('percent') ||
                       effect.type.includes('boost') ||
                       effect.type.includes('resistance') ||
                       effect.type.includes('killer') ||
                       effect.type.includes('lifesteal') ||
                       effect.type.includes('inflict') ||
                       effect.type.includes('chance') ||
                       effect.type.includes('evasion');

      const scaledValue = isPercent
        ? baseValue * totalMult  // %効果は倍率適用
        : Math.floor(baseValue * totalMult); // 固定値は切り捨て

      // 両フィールドを更新して互換性を維持
      return {
        ...effect,
        value: scaledValue,
        bonus: scaledValue,
      };
    });
  }

  // 旧形式: EQUIPMENT_BASE_DATA から取得
  const baseData = getEquipmentData(equipment.baseId || equipment.id);
  if (!baseData) return [];

  const rarityMult = RARITY_MULTIPLIER[equipment.rarity || baseData.rarity] || 1;
  const enhanceMult = ENHANCE_MULTIPLIER[equipment.enhanceLevel || 0] || 1;
  const totalMult = rarityMult * enhanceMult;

  return baseData.effects.map((effect) => ({
    ...effect,
    value: effect.type.includes('PERCENT') || effect.type.includes('RATE')
      ? effect.value * totalMult  // %効果は倍率適用
      : Math.floor(effect.value * totalMult), // 固定値は切り捨て
  }));
};
